import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import FilterForm from "../../components/Form/FilterForm";
import AttributeListGroup from "../../components/Attribute/ListGroup";

const AttributeIndex = ({classes, rootDispenser, filter, lifeCycleRates, categoryOptions, intervalUnits}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('attribute.title')}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('attribute.add'),
                    href: '/attributes/create',
                }
            ]}
        >
            <FilterForm
                url="/attributes"
                filter={filter}
                inputPlaceholder={i18n.get('attribute.form.search_value')}
                buttonTitle={i18n.get('attribute.form.search')}
            />
        </Toolbar>

        <Paper className={classes.paper}>
            <AttributeListGroup
                group={rootDispenser}
                lifeCycleRates={lifeCycleRates}
                categoryOptions={categoryOptions}
                intervalUnits={intervalUnits}
            />
        </Paper>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(AttributeIndex);